const FLOOR_SESSION_KEY = 'beatq.merchant.floorSession';

export type FloorMode = 'kitchen' | 'picker' | 'counter';

export function markFloorSession(active: boolean): void {
  if (typeof localStorage === 'undefined') return;
  if (active) localStorage.setItem(FLOOR_SESSION_KEY, '1');
  else localStorage.removeItem(FLOOR_SESSION_KEY);
}

export function isFloorSessionActive(): boolean {
  if (typeof localStorage === 'undefined') return false;
  return localStorage.getItem(FLOOR_SESSION_KEY) === '1';
}

export function floorModeSwitcherPath(): string {
  return '/floor-mode-switcher';
}
